/* eslint-disable @typescript-eslint/no-explicit-any */

import { Env } from 'config/Env'

import { HttpClient, ApiRequestTypes } from '../../../utils/apiService/httpService'

export const TableDataCall = (requestBody: unknown, endPoint: string): Promise<any> =>
  HttpClient[ApiRequestTypes.post](`${Env.REACT_APP_API_URL + endPoint}`, requestBody)
